import i18n from '@/locale'
import Mousetrap from 'mousetrap'
import { GlobalEventType } from '@/constants'

/**
 * 修饰符只支持 ctrl,shift,alt,meta
 * MacOS 可用 option 替代 alt, command 替代 meta
 * 特殊键: backspace, tab, enter, return, capslock, esc, escape, space, pageup, pagedown, end, home, left, up, right, down, ins, del, plus
 */
export const KeyboardActions = [
  {
    label: i18n.t('新增'),
    value: 'f10',
    handler() {
      this.$GlobalEventBus.emit(GlobalEventType.ADD)
      return false
    },
  },

  {
    label: i18n.t('保存'),
    value: 'f4',
    handler() {
      this.$GlobalEventBus.emit(GlobalEventType.SAVE)
      return false
    },
  },

  {
    label: i18n.t('入账'),
    value: 'f6',
    handler() {
      this.$GlobalEventBus.emit(GlobalEventType.RECORDING)
      return false
    },
  },

  {
    label: i18n.t('打印'),
    value: 'p',
    handler() {
      this.$GlobalEventBus.emit(GlobalEventType.PRINT)
      return false
    },
  },

  {
    label: i18n.t('快速添加'),
    value: 'f8',
    handler() {
      this.$GlobalEventBus.emit(GlobalEventType.FAST_ADD)
      return false
    },
  },

  {
    label: i18n.t('取消/返回'),
    value: 'esc',
    handler() {
      this.$GlobalEventBus.emit(GlobalEventType.CANCEL)
      return false
    },
  },

  {
    label: i18n.t('切换上一个'),
    value: 'up',
    handler() {
      this.$GlobalEventBus.emit(GlobalEventType.UP)
      return false
    },
  },

  {
    label: i18n.t('切换下一个'),
    value: 'down',
    handler() {
      this.$GlobalEventBus.emit(GlobalEventType.DOWN)
      return false
    },
  },
  {
    label: i18n.t('启用'),
    value: 'q',
    handler() {
      this.$GlobalEventBus.emit(GlobalEventType.ENABLE)
      return false
    },
  },
  {
    label: i18n.t('删除'),
    value: 'd',
    handler() {
      this.$GlobalEventBus.emit(GlobalEventType.REMOVE)
      return false
    },
  },
  {
    label: i18n.t('更换客户'),
    value: 'f3',
    handler() {
      this.$GlobalEventBus.emit(GlobalEventType.CUSTOMER_CHANGE)
      return false
    },
  },
]

/**
 * 新收银/新结算走快捷键中心，与全局 keyboard 重叠的键需在对应路由 suspend，避免 stopPropagation 挡住中心。
 * 旧 cashier/payPanel 不受影响。
 */
export const NEW_CASHIER_GLOBAL_SUSPEND_KEYS = ['up', 'down', 'p', 'd', 'f3', 'f8', 'f10']

export function bindGlobalKeyboard(vuePrototype) {
  KeyboardActions.forEach((item) => {
    Mousetrap.bind(item.value, item.handler.bind(vuePrototype))
  })
}

export function suspendGlobalKeyboardForNewCashier() {
  Mousetrap.unbind(NEW_CASHIER_GLOBAL_SUSPEND_KEYS)
}

export function resumeGlobalKeyboardForNewCashier(vuePrototype) {
  KeyboardActions.filter((item) => NEW_CASHIER_GLOBAL_SUSPEND_KEYS.includes(item.value)).forEach((item) => {
    Mousetrap.bind(item.value, item.handler.bind(vuePrototype))
  })
}

const install = (Vue) => {
  bindGlobalKeyboard(Vue.prototype)
}
export default install
